import { render } from "./CashbackDetail.vue?vue&type=template&id=36cbe155"
import script from "./CashbackDetail.vue?vue&type=script&lang=js"
export * from "./CashbackDetail.vue?vue&type=script&lang=js"

import "./CashbackDetail.vue?vue&type=style&index=0&id=36cbe155&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__